module.exports = __webpack_public_path__ + "b3162c4c002f4da98aaaff3afe331117.jpg";